import { TextAnnotation, FontFamily } from "../api/types";

const FONT_MAP: Record<FontFamily, string> = {
  interBold: '"Inter", sans-serif',
  robotoSlabBold: '"Roboto Slab", serif',
  leagueGothic: '"League Gothic", "Arial Narrow", sans-serif',
};
const DEFAULT_FONT_FAMILY = FONT_MAP.interBold;

function escapeXml(s: string): string {
  return s
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

export function buildTextLayer(play: { text_tag_list: TextAnnotation[] }): string {
  return play.text_tag_list
    .map((ann) => {
      const { position: { x, y }, text, color, backgroundColor, fontSize, fontFamily: ff, isBold, isItalic } = ann;
      const fontFamily = FONT_MAP[ff] ?? DEFAULT_FONT_FAMILY;
      const fontWeight = isBold ? "bold" : "normal";
      const fontStyle = isItalic ? "italic" : "normal";

      const estimatedWidth = Math.max(100, fontSize * 0.6 * text.length) + 16;
      const bgHeight = fontSize + 8;

      const bg = backgroundColor
        ? `<rect x="${x - estimatedWidth / 2}" y="${y - bgHeight / 2}"
            width="${estimatedWidth}" height="${bgHeight}"
            fill="${backgroundColor}" rx="3"/>`
        : "";

      return `${bg}
<text x="${x}" y="${y}" text-anchor="middle" dominant-baseline="central"
  font-family="${escapeXml(fontFamily)}" font-size="${fontSize}"
  font-weight="${fontWeight}" font-style="${fontStyle}" fill="${color}">${escapeXml(text)}</text>`;
    })
    .join("\n");
}
